export enum InventoryPageQueryKeys {
  SaveQueryModalOpen = 'saveQuery',
  EditQueryModalOpen = 'editQuery',
  Query = 'query',
  ResourceId = 'resourceId',
  SavedQueryId = 'accessScopeId',
  UseInAccessFlow = 'useInAccessFlow',
}
